import Icons from "./icons";

const About = () => {
    return(
        <>
          <div className="about" id="about">
            <h1 className="about_title" data-aos="fade-up">About Me</h1>
          
           <main className="profile" data-aos="flip-right" data-aos-delay="200"
>
             <div className="profile_img"><img src="../Images/aman2.png" alt="profile"></img></div>
             <div className="profile_details">
                <div  className="user_name"><h1>Aman Verma</h1></div>
                <div className="user_info">
                    <span>
                    Hi, I'm Aman Verma, an aspiring engineer currently pursuing my studies at Birla Institute of Technology, Mesra (2020-2024). 
                    Passionate about web development and coding, I enjoy exploring the world of competitive programming. 
                    With a knack for logical reasoning, brainstorming, and problem-solving, I thrive on challenges. 
                    Beyond my technical expertise, I find joy in activities like drawing and occasionally embarking on adventures.               
                    </span>
                </div>
                <Icons/>
             </div>
           </main>
          </div>
        </>
    )
}

export default About